import { render, staticRenderFns } from "./accession-general-modal.vue?vue&type=template&id=f8ecf1e0"
import script from "./accession-general-modal.vue?vue&type=script&lang=js"
export * from "./accession-general-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports